import { render, staticRenderFns } from "./AudioRecorder.vue?vue&type=template&id=1e3e07a6&scoped=true&"
import script from "./AudioRecorder.vue?vue&type=script&lang=ts&"
export * from "./AudioRecorder.vue?vue&type=script&lang=ts&"
import style0 from "./AudioRecorder.vue?vue&type=style&index=0&id=1e3e07a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3e07a6",
  null
  
)

export default component.exports